<template>
  <div class="fx-1 bgc-w of-a pt-20 pb-20 pl-20 pr-20">
    <div class="" v-html="trainingDoc"></div>
  </div>
</template>

<script>
import { getTrainingDoc } from "@api/user";
export default {
  data() {
    return {
      trainingDoc: ""
    };
  },

  created() {
    this.getInfo();
  },

  methods: {
    getInfo() {
      getTrainingDoc().then(res => {
        const result = res.data;
        let content = "";
        result.forEach(item => {
          content += item.content;
        });
        this.trainingDoc = content;
      });
    }
  }
};
</script>

<style>
ul,
ol {
  padding-left: 14px;
}
</style>

<style lang="scss" scoped>
/*常用样式*/
.dp-b {
  display: block;
}
.dp-i {
  display: inline;
}

.pos-r {
  position: relative;
}
.pos-a {
  position: absolute;
}
.pos-f {
  position: fixed;
}

.f-l {
  float: left;
}
.f-r {
  float: right;
}

.of-h {
  overflow: hidden;
}
.of-a {
  overflow: auto;
}

/*文字单行溢出省略号*/
.text-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mt-4 {
  margin-top: 4px;
}
.mt-5 {
  margin-top: 5px;
}
.mt-8 {
  margin-top: 8px;
}
.mt-10 {
  margin-top: 10px;
}
.mt-12 {
  margin-top: 12px;
}
.mt-15 {
  margin-top: 15px;
}
.mt-16 {
  margin-top: 16px;
}
.mt-20 {
  margin-top: 20px;
}
.mt-24 {
  margin-top: 24px;
}

.mb-4 {
  margin-bottom: 4px;
}
.mb-5 {
  margin-bottom: 5px;
}
.mb-6 {
  margin-bottom: 6px;
}
.mb-7 {
  margin-bottom: 6px;
}
.mb-8 {
  margin-bottom: 8px;
}
.mb-10 {
  margin-bottom: 10px;
}
.mb-12 {
  margin-bottom: 12px;
}
.mb-16 {
  margin-bottom: 16px;
}
.mb-18 {
  margin-bottom: 18px;
}
.mb-20 {
  margin-bottom: 20px;
}
.mb-24 {
  margin-bottom: 24px;
}
.mb-32 {
  margin-bottom: 32px;
}
.mb-48 {
  margin-bottom: 48px;
}

.ml-4 {
  margin-left: 4px;
}
.ml-5 {
  margin-left: 5px;
}
.ml-8 {
  margin-left: 8px;
}
.ml-10 {
  margin-left: 10px;
}
.ml-12 {
  margin-left: 12px;
}
.ml-15 {
  margin-left: 15px;
}
.ml-16 {
  margin-left: 16px;
}
.ml-20 {
  margin-left: 20px;
}
.ml-24 {
  margin-left: 24px;
}

.mr-4 {
  margin-right: 4px;
}
.mr-5 {
  margin-right: 5px;
}
.mr-8 {
  margin-right: 8px;
}
.mr-10 {
  margin-right: 10px;
}
.mr-12 {
  margin-right: 12px;
}
.mr-15 {
  margin-right: 15px;
}
.mr-16 {
  margin-right: 16px;
}
.mr-20 {
  margin-right: 20px;
}
.mr-24 {
  margin-right: 24px;
}

.pt-4 {
  padding-top: 4px;
}
.pt-8 {
  padding-top: 8px;
}
.pt-10 {
  padding-top: 10px;
}
.pt-12 {
  padding-top: 12px;
}
.pt-14 {
  padding-top: 14px;
}
.pt-16 {
  padding-top: 16px;
}
.pt-20 {
  padding-top: 20px;
}
.pt-24 {
  padding-top: 24px;
}

.pb-4 {
  padding-bottom: 4px;
}
.pb-8 {
  padding-bottom: 8px;
}
.pb-10 {
  padding-bottom: 10px;
}
.pb-12 {
  padding-bottom: 12px;
}
.pb-16 {
  padding-bottom: 16px;
}
.pb-20 {
  padding-bottom: 20px;
}
.pb-24 {
  padding-bottom: 24px;
}
.pb-32 {
  padding-bottom: 32px;
}
.pb-52 {
  padding-bottom: 52px;
}

.pl-4 {
  padding-left: 4px;
}
.pl-8 {
  padding-left: 8px;
}
.pl-10 {
  padding-left: 10px;
}
.pl-12 {
  padding-left: 12px;
}
.pl-16 {
  padding-left: 16px;
}
.pl-20 {
  padding-left: 20px;
}
.pl-24 {
  padding-left: 24px;
}
.pl-32 {
  padding-left: 32px;
}

.pr-4 {
  padding-right: 4px;
}
.pr-8 {
  padding-right: 8px;
}
.pr-10 {
  padding-right: 10px;
}
.pr-12 {
  padding-right: 12px;
}
.pr-16 {
  padding-right: 16px;
}
.pr-20 {
  padding-right: 20px;
}
.pr-24 {
  padding-right: 24px;
}

//圆角
.brs-2 {
  border-radius: 2px;
}
.brs-3 {
  border-radius: 3px;
}
.brs-4 {
  border-radius: 4px;
}
.brs-5 {
  border-radius: 5px;
}

//文字尺寸
.f-12 {
  font-size: 12px !important;
}
.f-13 {
  font-size: 13px !important;
}
.f-14 {
  font-size: 14px !important;
}
.f-15 {
  font-size: 15px !important;
}
.f-16 {
  font-size: 16px !important;
}
.f-17 {
  font-size: 17px !important;
}
.f-18 {
  font-size: 18px !important;
}
.f-20 {
  font-size: 20px !important;
}
.f-24 {
  font-size: 24px !important;
}
.f-26 {
  font-size: 26px !important;
}
.f-28 {
  font-size: 28px !important;
}
.f-30 {
  font-size: 30px !important;
}
.f-32 {
  font-size: 32px !important;
}

// 文字粗细
.bold {
  font-weight: bold !important;
}

//对齐
.ta-l {
  text-align: left !important;
}
.ta-r {
  text-align: right !important;
}
.ta-c {
  text-align: center !important;
}
.va-t {
  vertical-align: top !important;
}
.va-m {
  vertical-align: middle !important;
}
.va-b {
  vertical-align: bottom !important;
}

/* 文字颜色 */
.c-0 {
  color: #000000 !important;
}
.c-2 {
  color: #212121 !important;
} /*rgba(0,0,0,.87)*/
.c-3 {
  color: #333333 !important;
}
.c-5 {
  color: #525252 !important;
}
.c-6 {
  color: #666666 !important;
} /*rgba(0,0,0,.54)*/
.c-7 {
  color: #7e7e7e !important;
}
.c-8 {
  color: #808080 !important;
}
.c-9 {
  color: #9e9e9e !important;
} /*rgba(0,0,0,.38)*/
.c-a {
  color: #ababab !important;
}
.c-b {
  color: #bbb !important;
}
.c-c {
  color: #c0c0c0 !important;
}
.c-e {
  color: #efefef !important;
}
.c-f {
  color: #fff !important;
}
.c-yellow {
  color: #fdae01 !important;
}
.c-orange {
  color: #ff6701 !important;
}
.c-blue {
  color: #3985f5 !important;
}
.c-green {
  color: #88c267 !important;
}
.c-red {
  color: #ef5152 !important;
}
.c-placeholder {
  color: #ccc !important;
}

/* 背景颜色 */
.bgc-w {
  background-color: #fff !important;
}
.bgc-t {
  background-color: transparent !important;
}
.bgc-gray,
.bgc-grey {
  background-color: #eaeaea !important;
}
.bgc-base {
  background-color: #f5f5f5 !important;
}
.bgc-blue {
  background-color: #2fa0ed !important;
}
.bgc-green {
  background-color: #88c267 !important;
}
.bgc-orange {
  background-color: #ff6701 !important;
}
.bgc-yellow {
  background-color: #fce051 !important;
}
.bgc-red {
  background: #ef5152 !important;
}

//flex布局
.fx {
  display: flex;
}

.inline-fx {
  display: inline-flex;
}

.fx-v {
  flex-direction: column;
}

.fx-1 {
  flex: 1 1 auto;
}

.fx-1-0 {
  flex: 1 0 auto;
}

.fx-n {
  flex: 0 0 auto;
}

.fx-align-start {
  align-items: flex-start;
}

.fx-align-center {
  align-items: center;
}

.fx-align-end {
  align-items: flex-end;
}

.fx-justify-center {
  justify-content: center;
}

.fx-justify-end {
  justify-content: flex-end;
}

.fx-justify-between {
  justify-content: space-between;
}

.fx-justify-around {
  justify-content: space-around;
}
.fx-wrap {
  flex-wrap: wrap;
}

/* 边框线 */

.bline,
.tline,
.lline,
.rline,
.kline {
  position: relative;
}

.bline:after {
  content: "";
  position: absolute;
  z-index: 1;
  left: 0;
  right: 0;
  bottom: -1px;
  border-top: 1px solid #ededed;
}

.bline.xv:after {
  border-top-style: dashed;
}

.tline:before,
.lline:before,
.rline:before {
  content: "";
  position: absolute;
  z-index: 1;
  top: 0;
}

.tline:before {
  left: 0;
  right: 0;
  border-top: 1px solid #ededed;
}

.lline:before {
  bottom: 0;
  left: 0;
  border-left: 1px solid #ededed;
}

.rline:before {
  bottom: 0;
  right: -1px;
  border-right: 1px solid #ededed;
}

.rline.xv:before {
  border-right-style: dashed;
}

.dashed:before {
  border-top-style: dashed;
}

.dashed.bline:after,
.dashed.tline:before {
  /* 底部1像素虚线 */
  border-top: 1px dashed #ededed;
}

@media only screen and (-webkit-min-device-pixel-ratio: 1.5),
  (min-resolution: 120dpi),
  (-ms-high-contrast: active),
  (-ms-high-contrast: none) {
  .kline:after {
    width: 200%;
    height: 200%;
    -webkit-transform: scale(0.5);
    -moz-transform: scale(0.5);
    -ms-transform: scale(0.5);
    -o-transform: scale(0.5);
    transform: scale(0.5);
    -webkit-transform-origin: 0 0;
    -moz-transform-origin: 0 0;
    -ms-transform-origin: 0 0;
    -o-transform-origin: 0 0;
    transform-origin: 0 0;
  }

  .bline:after,
  .tline:before {
    -webkit-transform: scaleY(0.5);
    -moz-transform: scaleY(0.5);
    -ms-transform: scaleY(0.5);
    -o-transform: scaleY(0.5);
    transform: scaleY(0.5);
    -webkit-transform-origin: 100% 0;
    -moz-transform-origin: 100% 0;
    -ms-transform-origin: 100% 0;
    -o-transform-origin: 100% 0;
    transform-origin: 100% 0;
  }

  .lline:before,
  .rline:before {
    -webkit-transform: scaleX(0.5);
    -moz-transform: scaleX(0.5);
    -ms-transform: scaleX(0.5);
    -o-transform: scaleX(0.5);
    transform: scaleX(0.5);
    -webkit-transform-origin: 0 100%;
    -moz-transform-origin: 0 100%;
    -ms-transform-origin: 0 100%;
    -o-transform-origin: 0 100%;
    transform-origin: 0 100%;
  }
}

@media only screen and (-webkit-device-pixel-ratio: 1.5) {
  .kline:after {
    width: 150%;
    height: 150%;
    -webkit-transform: scale(0.6666);
    -moz-transform: scale(0.6666);
    -ms-transform: scale(0.6666);
    -o-transform: scale(0.6666);
    transform: scale(0.6666);
  }

  .bline:after,
  .tline:before {
    -webkit-transform: scaleY(0.6666);
    -moz-transform: scaleY(0.6666);
    -ms-transform: scaleY(0.6666);
    -o-transform: scaleY(0.6666);
    transform: scaleY(0.6666);
  }

  .lline:before,
  .rline:before {
    -webkit-transform: scaleX(0.6666);
    -moz-transform: scaleX(0.6666);
    -ms-transform: scaleX(0.6666);
    -o-transform: scaleX(0.6666);
    transform: scaleX(0.6666);
  }
}

@media only screen and (-webkit-device-pixel-ratio: 3) {
  .kline:after {
    width: 300%;
    height: 300%;
    -webkit-transform: scale(0.3333);
    -moz-transform: scale(0.3333);
    -ms-transform: scale(0.3333);
    -o-transform: scale(0.3333);
    transform: scale(0.3333);
  }

  .bline:after,
  .tline:before {
    -webkit-transform: scaleY(0.3333);
    -moz-transform: scaleY(0.3333);
    -ms-transform: scaleY(0.3333);
    -o-transform: scaleY(0.3333);
    transform: scaleY(0.3333);
  }

  .lline:before,
  .rline:before {
    -webkit-transform: scaleX(0.3333);
    -moz-transform: scaleX(0.3333);
    -ms-transform: scaleX(0.3333);
    -o-transform: scaleX(0.3333);
    transform: scaleX(0.3333);
  }
}
</style>
